import * as React from "react";

import { GlideFunctionalRenderer } from "common/components/uis";
import { getLocalizedString } from "common/components/localization";
import { loadedDefinedMap, asBoolean, asString } from "common/components/component-helpers";
import { ActionSource } from "common/components/computation-types";
import SignatureFieldView from "../ui/views/signature-field/signature-field-view";
import { dontAwait, isEmptyOrUndefined } from "common/Support";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useForce } from "hooks/use-force";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useNetworkStatus } from "hooks/use-network-status";

export const SignatureFieldMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [
        [placeholder, imageURL, onTap, onChange, isEnabledValue, titleValue, isRequiredValue],
        [, imageURLVP, , , , , , validFlagVP],
    ] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: onChangeCB } = useOnClickFromAction(onChange, ActionSource.Signature, ctx, env);
    const { onClick: onClickCB } = useOnClickFromAction(onTap, ActionSource.Signature, ctx, env);
    const onLine = useNetworkStatus();

    const onClear = React.useCallback(() => {
        if (imageURLVP === undefined) return;
        imageURLVP.set("");
        if (onChangeCB !== undefined) {
            dontAwait(onChangeCB(undefined));
        }
    }, [imageURLVP, onChangeCB]);

    const placeholderValue = loadedDefinedMap(placeholder, asString);
    if (placeholderValue === undefined) return null;

    const isEnabled = onLine && (loadedDefinedMap(isEnabledValue, asBoolean) ?? true);
    const onTapHandler = onClickCB !== undefined ? () => onClickCB(undefined) : undefined;

    const imageUrlValue = loadedDefinedMap(imageURL, asString);
    if (isRequiredValue === true && validFlagVP !== undefined && isEmptyOrUndefined(imageUrlValue)) {
        validFlagVP.set(false);
    }

    return (
        <SignatureFieldView
            isEnabled={isEnabled}
            title={loadedDefinedMap(titleValue, asString) ?? getLocalizedString("signature")}
            placeholder={placeholderValue}
            onTap={onTapHandler}
            onClear={onClear}
            imageUrl={imageUrlValue}
        />
    );
};
